export default __webpack_public_path__ + "static/media/noun_bag_3747465.137fc2ca.svg";